<div class="item-selection-container">
  <div *ngIf="items.length > 0">
    <h3>
      <mat-checkbox
        (change)="onToggleSelectAll()"
        [formControl]="selectAllState"
        [indeterminate]="selectAllState.value === null">
        Target {{ label }} {{ selectedIds.size }} *
      </mat-checkbox>
    </h3>
    <div class="items-container" [formGroup]="form">
      <ng-container formArrayName="items">
        <mat-checkbox
          *ngFor="let item of items; let i = index; trackBy: trackByItemId"
          [value]="item.id"
          [formControlName]="i">
          {{ item.name }}
        </mat-checkbox>
      </ng-container>
    </div>
  </div>

  <div *ngIf="items.length === 0">
    <p>No {{ label }} found</p>
    <small>Try adjusting your search or filters</small>
  </div>
</div>
